import { connect } from 'react-redux';
import { ModalProvider } from 'core';

let NAME = {
  // VERIFICATION: require('./Verification').default,
  JOIN_GROUP: require('./JoinGroup').default,
  NEW_GROUP: require('./NewGroup').default,
  ADD_ACCOUNT: require('./AddAccount').default,
  ADD_TASK: require('./AddTask').default,
  EDIT_TASK: require('./EditTask').default,
  CONTACTS_LIST: require('./ContactsList').default,
  CONTACT_PROFILE: require('./ContactProfile').default,
  REMOVE_MEMBER: require('./RemoveMember').default,
  MAP: require('./Map').default,
  BLOCK_LIST: require('./BlockList').default,
  EDIT_GROUP: require('./EditGroup').default,
  CHANGE_NAME: require('./ChangeName').default,
  SUBMISSIONS: require('./Submissions').default

  // MATERIAL_LINK: require('./modals/MaterialLinkPopUp').default,
  // GROUP_IMAGE_CHANGE: require('./modals/GroupPictureChagnePopUp').default,
  // ALTER_GROUP: require('./modals/AlterGroupPopUp').default,
};

const mapToProps = state => ({
  Content: state.ui.modal_name && state.ui.modal_name.length > 0 ? NAME[state.ui.modal_name] : null
});

export default connect(mapToProps)(ModalProvider);



// WEBPACK FOOTER //
// ./src/containers/modals/index.js